import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapActions, mapMutations } from 'vuex';
import { groupMixin } from '../mixin/group';
import { gameConfigCategoryResourceType, i18nCategoryResourceType } from '@/store/creative/common/category';

export default {
  mixins: [groupMixin],

  props: {
    category: {
      type: Object,
      required: true
    },

    config: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false
    };
  },


  methods: _extends({}, mapMutations({
    addI18nResource: 'creative/template/addI18nResource',
    addCategoryGameConfigResource: 'creative/template/addCategoryGameConfigResource'
  }), mapActions({
    rebuildCategory: 'creative/template/rebuildCategory',
    updateGroupsConfig: 'creative/template/updateGroupsConfig'
  }), {
    add: function add() {
      if (this.category.resource_type === i18nCategoryResourceType) {
        this.addI18n();
      }
      if (this.category.resource_type === gameConfigCategoryResourceType) {
        this.addGameConfig();
      }
    },
    addI18n: function addI18n() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.addI18nResource({
                  category: _this.category,
                  config: _this.config
                });
                _context.next = 3;
                return _this.rebuildCategory();

              case 3:
                _this.updateGroupsConfig();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addGameConfig: function addGameConfig() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.loading = true;
                _this2.addCategoryGameConfigResource({
                  category: _this2.category,
                  config: _this2.config
                });
                // 由于计算组合比较耗时，加入定时器好让 UI 渲染优先于早于数据计算，优化体验；
                setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2.rebuildCategory();

                        case 2:
                          _context2.next = 4;
                          return _this2.updateGroupsConfig();

                        case 4:
                          _this2.loading = false;

                        case 5:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                })), 0);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  })
};